(function ($) {
  $.fn.menumaker = function (options) {
    const settings = $.extend({
      title: "Menu",
      format: "language-changer",
      sticky: false
    }, options);
    return this.each(function () {
      const nav = $(this);
      nav.find("li ul, li .mega-dropdown").parent().addClass("has-sub");
      if (settings.format === "multitoggle") {
        nav.find(".has-sub").prepend('<button class="submenu-button" aria-label="Toggle Submenu"></button>');
        nav.find(".submenu-button").on("click", function () {
          $(this).toggleClass("submenu-opened");
          $(this).parent().toggleClass("parent-active");
          $(this).siblings("ul, .mega-dropdown").slideToggle().toggleClass("open");
        });
      } else {
        nav.addClass("language-changer");
      }
      if (settings.sticky) nav.css("position", "fixed");
      const resizeFix = () => {
        const width = $(window).width();
        if (width > 1024) {
          nav.find("ul, .mega-dropdown").show();
        } else {
          nav.find("ul, .mega-dropdown").hide().removeClass("open");
        }
      };
      $(window).on("resize", resizeFix);
      resizeFix();
    });
  };
  $(document).ready(() => {
    $(".mega-dropdown").parent().addClass("has-mega");
    $("#sidebar-nav").menumaker({ format: "multitoggle" });
  });
})(jQuery);
// Sidebar Toggle for Small Screens
$(document).on("click", (e) => {
  const isNavTrigger = $(e.target).closest(".nav-trigger").length;
  const isInsideSidebar = $(e.target).closest("#sidebar-nav").length;
  if (isNavTrigger) {
    e.preventDefault();
    $("html").toggleClass("sidebar_active");
    $(".nav-trigger").toggleClass("closemenu");
  } else if (!isInsideSidebar) {
    $("html").removeClass("sidebar_active");
    $(".nav-trigger").removeClass("closemenu");
  }
});
// Touch Device Check
const isTouchDevice = () => ('ontouchstart' in window || navigator.maxTouchPoints);
// Mega Menu Position Adjustments
if (!isTouchDevice()) {
  $(window).on("load", () => {
    setTimeout(() => {
      $("ul.nav > li.has-sub").hover(function () {
        const headerOffset = $("header").offset().left + $("header").width();
        const submenuOffset = $(this).find(".submenu-button").siblings("ul").offset().left;
        const submenuWidth = $(this).find(".submenu-button").siblings("ul").outerWidth();
        if (headerOffset < submenuOffset + submenuWidth) {
          $(this).addClass("align-left-menu");
        }
      }, function () {
        $(this).removeClass("align-left-menu");
      });
      $("ul.nav ul li.has-sub").hover(function () {
        const headerOffset = $("header").offset().left;
        const headerRight = headerOffset + $("header").width();
        const submenu = $(this).find(".submenu-button").siblings("ul");
        const submenuLeft = submenu.offset().left;
        const submenuRight = submenuLeft + submenu.outerWidth();
        if (headerRight < submenuRight) $(this).addClass("align-left-menu");
        if (headerOffset > submenuLeft) $(this).addClass("align-right-menu");
      }, function () {
        $(this).removeClass("align-left-menu align-right-menu");
      });
      $(".nav-wrap nav ul.nav ul .has-sub").each((i, el) => {
        $(el).css("z-index", 500 - i);
      });
    }, 200);
  });
}
// Mega Menu Width & Alignment
const navFuc = () => {
  const headerWidth = $("header").outerWidth();
  const windowWidth = $(window).width();
  const offsetLeft = (windowWidth - headerWidth) / 2;
  $(".nav-wrap nav ul.nav > li").each(function () {
    const pos = $(this).offset().left - offsetLeft;
    $(this).find(".mega-dropdown").css({ left: -pos, width: headerWidth });
  });
};
$(document).ready(navFuc);
$(window).on("resize", () => setTimeout(navFuc, 300));
// Header Shrink on Scroll
$(window).on("scroll", () => {
  $(window).scrollTop() >= 100
    ? $("html").addClass("head-fix")
    : $("html").removeClass("head-fix");
});
// Scroll to Top Button
$(window).on("scroll", () => {
  $(".scrollup").toggleClass("show", $(window).scrollTop() > 400);
});
$(".scrollup").on("click", (e) => {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, 500);
});
// Click Dropdown
$(document).on('click touchstart', function (fd) {
  var click_box = $(".search-triger, .search-block");
  if (!click_box.is(fd.target) && click_box.has(fd.target).length === 0) {
    jQuery('.search-triger').removeClass("active");
    jQuery(".search-block").hide();
  }
});
//Search
jQuery('.search-triger').click(function () {
  jQuery(this).toggleClass("active");
  jQuery(".search-block").fadeToggle();
});

// Notification Strip Close
$(".notification-close").on("click", function () {
  $(".notification-strip").remove();
  $("header").removeClass("has-notification");
});
// Image & Background Helpers
$(".alignright, .alignleft").closest("p").addClass("pn");
$(".bg img").each(function () {
  const imgSrc = $(this).attr("src");
  $(this).parent().css("background-image", `url(${imgSrc})`);
});
// Responsive Table
$("table").wrap("<div class='table-responsive'></div>");
// Smooth Scroll
$(".smooth").on("click", function (e) {
  const target = $(this.hash);
  if (target.length) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: target.offset().top - 150 }, 500);
  }
});
// Sidebar Toggle (Icon)
$(".small-icon-trigger").on("click", function () {
  $(this).toggleClass("active").next().slideToggle();
});
// Filter Toggle
$(".all-open .filter-head").addClass("active");
$(".all-open .filter-content").slideDown().addClass("active");
$(".first-open .filter-head:first").addClass("active");
$(".first-open .filter-content:first").slideDown().addClass("active");
$(".filter-head").on("click", function () {
  $(this).toggleClass("active").next(".filter-content").slideToggle().toggleClass("active");
});
// Anchor Toggle Box
$(".tab-click a").on("click", function (e) {
  const id = this.hash;
  const $target = $(id);
  if ($target.length) {
    e.preventDefault();
    $(".tab-click a").removeClass("active");
    $(this).addClass("active");
    $(".tab-panel").not(id).hide().removeClass("active");
    $target.fadeIn().addClass("active");
  }
});
// Accordion
$(".all-faq .accordion-data:first .accordion-head").addClass("active");
$(".all-faq .accordion-data:first .accordion-content").slideDown().addClass("active");
$(".accordion-data").on("click", function () {
  const content = $(this).children(".accordion-content");
  const isActive = content.hasClass("active");
  $(".accordion-head").removeClass("active");
  $(".accordion-content").slideUp().removeClass("active");
  if (!isActive) {
    $(this).children(".accordion-head").addClass("active");
    content.slideDown().addClass("active");
  }
});

// Smooth scroll
$('.smooth').click(function (event) {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      var headerHeight = $('header').outerHeight() || 0;
      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 500);
    }
  }
});